module.exports = __webpack_public_path__ + "img/aa_icon.fa68ea94.png";